import { httpRequest } from '@calendly/http-tools'
import { createAsyncThunk } from '@reduxjs/toolkit'

export const updateCreditCard = createAsyncThunk(
  'billing/updateCreditCard',
  async ({ token, billingInformation }, { rejectWithValue }) => {
    const [success, response] = await httpRequest({
      url: '/api/billing/subscription/card',
      method: 'PUT',
      data: {
        card_token: {
          id: token.id,
          livemode: token.livemode,
          card: {
            address_zip: token.card.address_zip,
            country: token.card.country,
            last4: token.card.last4,
          }
        },
        billing_information: billingInformation
      }
    })

    if (!success) {
      return rejectWithValue(response.message)
    }

    return response
  }
)
